import {
  LOADING_TT_ADVERTISERS,
  LOADING_TT_ADVERTISERS_SUCCESS,
  LOADING_TT_ADVERTISERS_FAILURE
} from '../constants/ttAdvertisersTypes'

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case LOADING_TT_ADVERTISERS:
      return {
        ...state,
        [actions.brandId]: {
            loading: true,
            success: null,
            data: null
          }
        }
    case LOADING_TT_ADVERTISERS_SUCCESS:
      return {
        ...state,
        [actions.brandId]: {
          loading: false,
          success: true,
          data: actions.data ? [...actions.data] : []
        }
      }
    case LOADING_TT_ADVERTISERS_FAILURE:
      return {
        ...state,
        [actions.brandId]: {
          loading: false,
          success: false,
          errors: actions.errors
        }
      }
    default:
      return state
  }
}
